document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-menu-overlay]');
  const closeButton = document.querySelector('[data-menu-close]');
  let lastFocus = null;

  const setMenu = (open) => {
    if (!toggle || !menu) return;
    menu.classList.toggle('open', open);
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    if (overlay) overlay.hidden = !open;
    body.classList.toggle('menu-open', open);
    if (open) {
      lastFocus = document.activeElement;
      menu.querySelector('a')?.focus();
    } else if (lastFocus === toggle || menu.contains(lastFocus)) {
      toggle.focus();
    }
  };

  toggle?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    setMenu(!menu.classList.contains('open'));
  }, true);
  overlay?.addEventListener('click', () => setMenu(false));
  closeButton?.addEventListener('click', () => setMenu(false));
  menu?.addEventListener('click', (event) => { if (event.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('open')) setMenu(false);
    if (event.key === 'Tab' && menu?.classList.contains('open')) {
      const focusable = [...menu.querySelectorAll('a[href],button:not([disabled])')].filter((item) => item.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('resize', () => { if (window.innerWidth >= 1024 && menu?.classList.contains('open')) setMenu(false); });

  window.StudioCosyDeliveryRules?.configureAll();

  let deliverySyncPending = false;
  let deliverySyncPromise = Promise.resolve();
  let deliverySyncValue = '';
  const formatDeliveryDate = (value) => {
    if (!value) return '';
    const date = new Date(`${value}T12:00:00`);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  };
  const syncDeliveryDate = (value, options = {}) => {
    if (!value) return Promise.resolve();
    const validation = window.StudioCosyDeliveryRules?.validateValue(value);
    if (validation && !validation.valid) {
      document.querySelectorAll('[data-cart-date-status]').forEach((status) => { status.textContent = validation.message; status.dataset.saved = 'false'; });
      return Promise.resolve(false);
    }
    if (!options.force && (deliverySyncPending || deliverySyncValue === value) && deliverySyncValue === value) return deliverySyncPromise;
    deliverySyncValue = value;
    deliverySyncPending = true;
    deliverySyncPromise = (async () => {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const label = 'Gewenste leverdatum:';
      const existingLines = String(cart.note || '').split('\n').filter((line) => line.trim() && !line.trim().startsWith(label));
      const readable = formatDeliveryDate(value);
      existingLines.push(`${label} ${readable}`);
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: existingLines.join('\n'), attributes: { 'Gewenste leverdatum': value } })
      });
      if (!response.ok) throw new Error('Leverdatum kon niet worden opgeslagen');
      document.querySelectorAll('[data-sc-delivery-date], [data-cart-delivery-date]').forEach((input) => { if (input.value !== value) input.value = value; });
      document.querySelectorAll('[data-cart-date-status]').forEach((status) => { status.textContent = `Opgeslagen voor je bestelling: ${readable}`; status.dataset.saved = 'true'; });
      document.dispatchEvent(new CustomEvent('studio-cosy:delivery-date-saved', { detail: { value, readable } }));
    })().catch(() => {
      deliverySyncValue = '';
      document.querySelectorAll('[data-cart-date-status]').forEach((status) => { status.textContent = 'Opslaan mislukt. Kies de datum opnieuw.'; status.dataset.saved = 'false'; });
    }).finally(() => { deliverySyncPending = false; });
    return deliverySyncPromise;
  };
  window.StudioCosyDeliveryDate = { sync: syncDeliveryDate, format: formatDeliveryDate };

  const detectFlare = () => {
    const flare = document.querySelector('[class*="flare" i],[id*="flare" i],script[src*="flare" i],iframe[src*="flare" i]');
    body.classList.toggle('has-flare-delivery', Boolean(flare));
    return Boolean(flare);
  };
  if (!detectFlare()) {
    const flareObserver = new MutationObserver(() => { if (detectFlare()) flareObserver.disconnect(); });
    flareObserver.observe(body, { childList: true, subtree: true });
    window.setTimeout(() => flareObserver.disconnect(), 10000);
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('input,select');
    if (!input?.value) return;
    const flareContainer = input.closest('[class*="flare" i],[id*="flare" i],[class*="fleur" i],[id*="fleur" i]');
    const identity = `${input.name} ${input.id} ${input.className} ${flareContainer?.className || ''} ${flareContainer?.id || ''}`;
    const isDeliveryField = input.matches('[data-sc-delivery-date],[data-cart-delivery-date],input[type="date"]') || /delivery.?date|leverdatum|bezorgdatum|(flare|fleur).*?(date|datum)|(date|datum).*?(flare|fleur)/i.test(identity);
    if (isDeliveryField) {
      const validation = window.StudioCosyDeliveryRules?.validate(input, { clearInvalid: true });
      if (validation && !validation.valid) return;
      syncDeliveryDate(input.value);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.querySelector?.('[name="checkout"]')) return;
    if (window.StudioCosyDeliveryRules && !window.StudioCosyDeliveryRules.validateAll()) {
      event.preventDefault();
      return;
    }
    if (!deliverySyncPending) return;
    event.preventDefault();
    deliverySyncPromise.finally(() => form.submit());
  }, true);

  document.querySelectorAll('form').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('button[type="submit"], button[name="checkout"]');
      if (!button || button.disabled) return;
      button.setAttribute('aria-busy', 'true');
      window.setTimeout(() => { button.disabled = true; }, 0);
      window.setTimeout(() => { button.disabled = false; button.removeAttribute('aria-busy'); }, 5000);
    });
  });
});
